import { Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { AppColors } from '../../../Utils/helper/AppColors';

export default function CircularProgress({
	value,
	total,
	color,
	size,
	hideBorders,
	hidePercentageSign,
	mul = 1,
	isCallInfo,
	toolTipMessageOnCirculerProgress = 'hi',
}) {
	return (
		<Stack position="relative">
			{hideBorders ? (
				<Stack alignItems="center" justifyContent="center">
					<Typography variant="body2" fontWeight={600} sx={{ position: 'absolute' }}>
						{value / mul || 0} 
						{total ? `/${total}` : ''}
						{!hidePercentageSign && '%'}
					</Typography>
					{/* <Tooltip
						title={
							<Stack direction="row" alignItems="center" gap={1}>
								<span>{toolTipMessageOnCirculerProgress || ''}</span>
							</Stack>
						}
						arrow={false}
						slotProps={{
							tooltip: {
								sx: {
									// bgcolor: AppColors.color[0],
									// color: AppColors.color[1],
									boxShadow: '0 0 4 0 #B9B9F780',
									borderRadius: '5px',
									fontSize: 14,
									fontWeight: 500,
								},
							},
						}}
					> */}
						<Stack width={size || 100} height={size || 100}>
							<CircularProgressbar
								strokeWidth={14}
								styles={buildStyles({
									pathTransitionDuration: 0.5,
									pathColor: isCallInfo ? AppColors.DARKER_PRIMARY : color[0],
									trailColor: isCallInfo ? AppColors.LIGHTER_SHADE : color[1],
									strokeLinecap: 'round',
								})}
								value={value || 0}
							/>
						</Stack>
					{/* </Tooltip> */}
				</Stack>
			) : (
				<Stack alignItems="center" justifyContent="center" bgcolor="#EEF0FA" width={200} height={200} borderRadius={50}>
					<Stack height={100} width={100} bgcolor="#fff" borderRadius={50} alignItems="center" justifyContent="center">
						<Typography variant="body1">
							{value / mul || 0}
							{!hidePercentageSign && '%'}
						</Typography>
						<Stack width={size || 170} height={size || 170} sx={{ position: 'absolute' }}>
							<CircularProgressbar
								strokeWidth={12}
								styles={buildStyles({
									pathTransitionDuration: 0.5,
									pathColor: color,
									trailColor: '#d7d6f7',
									strokeLinecap: 'butt',
								})}
								value={value || 0}
							/>
						</Stack>
					</Stack>
				</Stack>
			)}
		</Stack>
	);
}
